import { el, clear, olhoSenha } from '../lib/dom.js';
import { entrar } from '../lib/auth.js';
import { toast } from '../lib/toast.js';

/** Tela de login (renderiza no #app, sem layout). */
export function paginaLogin(aoEntrar) {
  return {
    render() {
      const app = document.getElementById('app');
      clear(app);

      const email = el('input', { type: 'email', placeholder: 'voce@huol.exemplo', autocomplete: 'username' });
      const senha = el('input', { type: 'password', placeholder: '••••••••', autocomplete: 'current-password' });
      const botao = el('button', { class: 'btn btn--primario', style: 'width:100%;justify-content:center;' }, 'Entrar');

      async function submeter(e) {
        e?.preventDefault();
        if (!email.value || !senha.value) { toast('Informe e-mail e senha.', 'erro'); return; }
        botao.disabled = true; botao.textContent = 'Entrando...';
        const { erro } = await entrar(email.value.trim(), senha.value);
        botao.disabled = false; botao.textContent = 'Entrar';
        if (erro) { toast(erro, 'erro'); return; }
        aoEntrar();
      }

      botao.addEventListener('click', submeter);
      const form = el('form', { onSubmit: submeter }, [
        el('img', { class: 'login__logo', src: '/logo_nome.png', alt: 'AcessaHUOL' }),
        el('p', { class: 'view__sub', style: 'text-align:center;margin-bottom:22px', text: 'Controle de Chaves' }),
        el('div', { class: 'campo' }, [el('label', { text: 'E-mail' }), email]),
        el('div', { class: 'campo' }, [el('label', { text: 'Senha' }), olhoSenha(senha)]),
        botao,
      ]);

      app.append(el('div', { class: 'login' }, [el('div', { class: 'login__card' }, [form])]));
      email.focus();
    },
  };
}
